import AttendeeAction from '../attendeeAction';
import ModerationPostAction from '../../post-action/moderationPostAction';
import { Attendee } from '../../../../models';

export default class ValidatedAction extends AttendeeAction {
    static NAME = 'validated';
    static POST_ACTION_COMPONENT = ModerationPostAction;
    static ASYNCHRONOUS_LIMIT_MIN = 50;

    static condition(attendee) {
        return attendee.moderation_status !== 'validated';
    }

    static is_available({ event }) {
        return event.is_moderation_enabled;
    }

    run() {
        return Promise.resolve(true);
    }
    get needs_selection() {
        return false;
    }

    get needs_confirm() {
        return false;
    }

    get post_action() {
        return true;
    }
    get is_direct() {
        return true;
    }

    runPostAction({ attendees, notifyAttendees }) {
        return Attendee.perform_action(
            'bulk_update_moderation_status',
            attendees,
            {
                organization: this.organization,
                event: this.event,
                notifyAttendees: notifyAttendees,
                moderationStatus: ValidatedAction.NAME
            },
            this.isAsync(attendees)
        );
    }

    onActionDone() {
        this.onClose();
        if (!this.async) {
            this.sync();
        }
    }
}
